import { useSearchParams } from 'react-router-dom'
import { useAppSelector } from 'state/store'
import { useTranslation } from 'react-i18n-lite'
import useWorkflow from './useWorkflow'
import { ExecutionState } from 'types/workflow'
import { FlatInteractionModelData } from 'types/shared'

type BaseInteractionConfig = FlatInteractionModelData['base_interaction']

const useBaseInteractionUuid = (
  baseInteractionConfig?: BaseInteractionConfig
): string | undefined => {
  const { t } = useTranslation()
  const { workflowUuid } = useAppSelector((state) => state.interactionModel)

  const { workflow: process } = useWorkflow({ t, workflowUuid })
  const [searchParams] = useSearchParams()

  if (!baseInteractionConfig) {
    return undefined
  }

  const { source, identifier } = baseInteractionConfig

  // If source is static_value, the identifier is the UUID itself
  if (source === 'static_value') {
    return identifier
  }

  // If source is query_string, get from URL parameters
  if (source === 'query_string') {
    return searchParams.get(identifier) || undefined
  }

  // If source is process_state, get from workflow execution state
  if (source === 'process_state') {
    const processState = JSON.parse(
      process?.execution_state || '{}'
    ) as ExecutionState
    return processState?.data_container?.[identifier]
  }

  return undefined
}

export default useBaseInteractionUuid
